//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getUserInfo from '@/common/utils/getUserInfo'
import callConsultant from '@/common/mixins/callConsultant'
import footer_btn from '../mixins/footer_btn'
import goConsultant from '@/common/mixins/goConsultant'
import { sendCtmEvtLog } from '@/utils/log'

export default {
    mixins: [
        callConsultant,
        footer_btn,
        goConsultant
    ],
    props: {
        is_consultant: {
            type: Boolean
        },
        current_house: {
            type: Object
        },
        house: {
            type: Object
        },
        is_selling: {
            type: Boolean
        }
    },
    data() {
        return {
            show_inner_tips: false
        }
    },
    mounted () {
        this.show_inner_tips = this.is_consultant
        setTimeout(() => {
            this.show_inner_tips = false
        }, 5000)
    },
    methods: {
        hideInnerTips () {
            this.show_inner_tips = false
        }
    }
};
